import TrackPlayer from 'react-native-track-player';
import { analytics, getRequestedContent, FileType, PlaybackEventEmitter, PlaybackEvent, usePlaybackStateStore, PlaybackState, } from '@annunciate/core';
const setPlaybackState = usePlaybackStateStore.getState().setState;
export const pausePlayers = async ({ content, switchingType = false } = {}) => {
    if (content) {
        const type = content?.asset?.type;
        switch (type) {
            case FileType.AUDIO:
                if (switchingType) {
                    await TrackPlayer.stop();
                    await TrackPlayer.setQueue([]);
                    setPlaybackState(content?.id, PlaybackState.NONE);
                }
                else {
                    try {
                        await TrackPlayer.pause();
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
                break;
            case FileType.VIDEO:
                PlaybackEventEmitter.emit(PlaybackEvent.VIDEO_PAUSE);
                if (switchingType) {
                    setPlaybackState(content.id, PlaybackState.NONE);
                }
                break;
            case FileType.EBOOK:
                setPlaybackState(content.id, PlaybackState.NONE);
        }
    }
    else {
        await TrackPlayer.pause();
        PlaybackEventEmitter.emit(PlaybackEvent.VIDEO_PAUSE);
    }
};
export const onPause = async ({ content } = {}) => {
    await pausePlayers({ content });
    let { type } = getRequestedContent(content);
    if (type === FileType.VIDEO) {
        return;
    }
    await analytics.emitContentEvent("pausing", { content });
    await analytics.emitPlaybackEvent("paused");
};
//# sourceMappingURL=onPause.js.map